import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// Licencia de DevExtreme 24.2 (cliente CUBE). Sin ella cada pantalla muestra el aviso naranja
// "For evaluation purposes only". Tiene que registrarse ANTES de crear cualquier widget.
import config from 'devextreme/core/config';
config({
  licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImE4OGEwOTg1LTljOTgtNDIxOS05NzAzLWM0NjllZGIxOTRhZSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.X/K//cfE3KCMoR8s4QargEIsCsx9zPEj3vfvHKeYrwn8e6/17u9gt01Pz/kFT+Bu0B+BcdCNDgSND+ELSdsaQmP0Pa+8bE67VqAHdXiWNVvm9842jDeI686mPSp4eKjWBrMkbg==',
});

// Export a Excel/PDF de todas las grillas (DevExtreme 24 ya no exporta solo con dxo-export)
import { registerGlobalGridExport } from './app/shared/grid-export/global-grid-export';
registerGlobalGridExport();

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // Suppress all diagnostic console output in production builds.
  // console.error is intentionally left intact for error-monitoring tools.
  window.console.log = () => {};
  window.console.warn = () => {};
  window.console.info = () => {};
  window.console.debug = () => {};
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
